import providerInstance from "../api-provider";
import billingInstance from "../api-billing";
import handleError from "../handleError";

export const getPatientList = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/getPatientList",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getDocuments = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/getDocuments",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getDocumentType = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/getDocumentType",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteDocument = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/deleteDocument",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getPayerMasterPatient = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/getPayerMaster",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const uploadDocumentPatient = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/uploadDocument",
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const updateDocument = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/updateDocument",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getDocument = async (payload, token) => {
  try {
    let { data } = await billingInstance({
      url: "/getDocument",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
      responseType: "blob",
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const addPatient = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/addPatient",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const editPatient = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/editPatient",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getPracticeLocationsPatient = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/getPracticeLocations",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getPracticeProviders = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/getPracticeProviders",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : undefined,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getPracticeTemplate = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/getPracticeTemplates",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log("error getPracticeTemplate: ", error);
  }
};
